import React, { useState } from 'react';
import { Captcha } from './Captcha';
const DEFAULT_PROGRAM_OPTIONS = ['Mini Troopers (Ages 3-5)', 'Kids Taekwondo (Ages 6+)', 'Adult Classes', 'Family Classes', 'Self-Defense', 'Competition Team', 'Summer Camp', 'General Question'] as const;
interface LeadFormProps {
  buttonText?: string;
  helperText?: string;
  /** Pre-select a program in the "Interested In" dropdown. */
  defaultProgram?: string;
  /** Override the program list (e.g. kids landing pages may surface fewer options). */
  programOptions?: readonly string[];
  /** Show the optional Child's Age field — useful for kids landing pages. */
  showChildAge?: boolean;
}
export function LeadForm({
  buttonText = 'Check Availability',
  helperText = "We'll help you choose the best starting class or program before your first visit.",
  defaultProgram = '',
  programOptions = DEFAULT_PROGRAM_OPTIONS,
  showChildAge = false
}: LeadFormProps) {
  const [captchaValid, setCaptchaValid] = useState(false);
  return (
    // NOTE: Placeholder front-end submission for the Magic Patterns preview.
    // In production, replace with the live WebsiteForge form embed so
    // submissions hit Storm Taekwondo's real inbox / CRM.
    <form action="/thank-you-free-trial" method="get" className="bg-paper p-8 rounded-2xl shadow-xl border border-subtle-gray w-full max-w-md mx-auto" data-id="element-347">
      <div className="flex flex-col gap-5 mb-6" data-id="element-348">
        <div data-id="element-349">
          <label htmlFor="fullName" className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-350">
            Full Name
          </label>
          <input type="text" id="fullName" name="fullName" required autoComplete="name" className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all" placeholder="Parent or Student Name" data-id="element-351" />
        </div>

        <div data-id="element-352">
          <label htmlFor="phone" className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-353">
            Phone Number
          </label>
          <input type="tel" id="phone" name="phone" required autoComplete="tel" className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all" placeholder="(517) 220-0621" data-id="element-354" />
        </div>

        <div data-id="element-355">
          <label htmlFor="email" className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-356">
            Email Address
          </label>
          <input type="email" id="email" name="email" required autoComplete="email" className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all" placeholder="email@example.com" data-id="element-357" />
        </div>

        <div data-id="element-358">
          <label htmlFor="interestedIn" className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-359">
            Interested In
          </label>
          <select id="interestedIn" name="interestedIn" required defaultValue={defaultProgram} className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all" data-id="element-360">
            <option value="" disabled data-id="element-361">
              Choose a class or program
            </option>
            {programOptions.map(opt => <option key={opt} value={opt} data-id="element-362">
                {opt}
              </option>)}
          </select>
        </div>

        {showChildAge && <div data-id="element-363">
            <label htmlFor="childAge" className="block text-sm font-bold text-ink mb-2 uppercase tracking-wide" data-id="element-364">
              Child's Age{' '}
              <span className="text-gray-warm font-normal normal-case text-xs" data-id="element-365">
                (optional)
              </span>
            </label>
            <input type="text" id="childAge" name="childAge" inputMode="numeric" className="w-full px-4 py-3 rounded-xl border border-subtle-gray bg-off-white focus:outline-none focus:ring-2 focus:ring-storm-red focus:border-transparent transition-all" placeholder="e.g. 6" data-id="element-366" />
          </div>}
      </div>

      <div className="mb-6" data-id="element-367">
        <Captcha onValidChange={setCaptchaValid} data-id="element-368" />
      </div>

      <button type="submit" disabled={!captchaValid} className="btn-primary w-full mb-4 disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-369">
        {buttonText}
      </button>

      <p className="text-xs text-gray-warm text-center leading-relaxed" data-id="element-370">
        {helperText}
      </p>
    </form>
  );
}